export const Translations_HU = {
	footer: {
		join: "Csatlakozz a beszélgetéshez most. Nincs szükség appra vagy bejelentkezésre.",
		climate: "Klímapozitív beszélgetés.",
		tree: "Ezt a fát ültettük.",
		start: "Indítsd el saját videóbeszélgetésed ingyen.",
	},
};
